import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import { format, eachDayOfInterval, startOfWeek, addDays } from 'date-fns';

import Day from './day';
import { useMonth } from '@spa/shared/hooks/dateRange';
import { MonthContainer, RowContainer, WeekDayContainer, WeekContainer } from './styles';
import { DATE_PICKER_SUPPORTED_LOCALES } from '@spa/shared/constants/date-picker-supported-locales';

const Month = ({ year, month, dateRange, hoverHandlers }) => {
  const { firstDayOfWeek } = dateRange;
  const { days } = useMonth({ year, month, firstDayOfWeek });
  const {
    t,
    i18n: { language }
  } = useTranslation();

  const [, setHoveredDate] = hoverHandlers;
  const currentLocale = DATE_PICKER_SUPPORTED_LOCALES[language] || undefined;
  const weekdayLabels = eachDayOfInterval({
    start: startOfWeek(new Date(), { weekStartsOn: 0 }),
    end: addDays(startOfWeek(new Date(), { weekStartsOn: 0 }), 6)
  }).map(day => t(format(day, 'EEE', { locale: currentLocale })));

  return (
    <React.Fragment>
      <WeekContainer>
        {weekdayLabels.map((weekDay, i) => (
          <WeekDayContainer key={i}>{weekDay}</WeekDayContainer>
        ))}
      </WeekContainer>
      <MonthContainer role="presentation" onMouseLeave={() => setHoveredDate(null)}>
        <tbody>
          {days.map((week, chunk) => (
            <RowContainer key={chunk}>
              {week.map(({ date, dayLabel } = {}, index) =>
                date && dayLabel ? (
                  <Day
                    date={date}
                    dateRange={dateRange}
                    key={date.toString()}
                    dayLabel={dayLabel}
                    hoverHandlers={hoverHandlers}
                  />
                ) : (
                  <Day dateRange={dateRange} key={`${chunk - index}`} />
                )
              )}
            </RowContainer>
          ))}
        </tbody>
      </MonthContainer>
    </React.Fragment>
  );
};

Month.propTypes = {
  year: PropTypes.number.isRequired,
  month: PropTypes.number.isRequired,
  dateRange: PropTypes.object.isRequired,
  hoverHandlers: PropTypes.array
};

export default Month;
